import React from 'react';
import { HouseholdMembershipPriceAccordionProps } from '../Types';
import * as S from './HouseholdMembershipPriceAccordion.styles';
import BlockContent from '../../block-content/BlockContent';

export const HouseholdMembershipPriceAccordion = ({ title, prices, terms }: HouseholdMembershipPriceAccordionProps) => (
  <S.StyledHouseholdAccordion headingLevel={3} title={title ?? ''} size="medium" hideDivider>
    <S.PriceList>
      {prices?.map((price) => (
        <S.PriceItem key={price?.title}>
          <S.Person variant="textInteractiveS">{price?.title}</S.Person>
          <S.Price>{price?.price} kr</S.Price>
        </S.PriceItem>
      ))}
    </S.PriceList>
    {terms && (
      <S.TermsContent>
        <S.TermsTitle variant="textInteractiveL" component="p">
          Betingelser
        </S.TermsTitle>
        <BlockContent value={terms} />
      </S.TermsContent>
    )}
  </S.StyledHouseholdAccordion>
);
